import { Navigate, useNavigate, useSearchParams } from 'react-router-dom'
import { PiMicrophone, PiCamera, PiPencilSimple } from 'react-icons/pi'
import { useFeatureFlagService } from 'utils/useFeatureFlagService'
import { MobileModal } from 'components/UI/Modal/MobileModal'

export default function MobileCreateContactChooser() {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const chainId = searchParams.get('chain_id')
  const { enableMobileContactAiPrefill, isLoading: flagsLoading } =
    useFeatureFlagService()

  // Preserve existing deep links (e.g. /contacts/create?chain_id=123) by
  // forwarding straight to the manual form with the param intact.
  if (chainId) {
    return (
      <Navigate to={`/contacts/create/manual?chain_id=${chainId}`} replace />
    )
  }

  // The Talk / Take-a-photo options (AI prefill) are gated behind
  // enable_mobile_contact_ai_prefill. With the flag off, the chooser has
  // nothing to offer beyond manual entry, so skip it and go straight to the
  // manual form. Wait for flags to load first so we don't flash the chooser
  // or redirect on a not-yet-loaded value.
  if (!flagsLoading && !enableMobileContactAiPrefill) {
    return <Navigate to="/contacts/create/manual" replace />
  }

  if (flagsLoading) {
    return null
  }

  return (
    <MobileModal
      handleBack={() => navigate(-1)}
      header={
        <div className="p-2">
          <div className="text-xs uppercase tracking-wide text-fg-tertiary mb-1">
            Create a contact
          </div>
          <h1 className="text-2xl font-semibold text-fg">
            How do you want to start?
          </h1>
        </div>
      }
      footer={<div />}
    >
      <div className="flex flex-col gap-3 p-4">
        <button
          type="button"
          disabled
          className="flex items-center gap-3 rounded-xl border border-line p-4 text-left opacity-50"
        >
          <PiMicrophone className="w-7 h-7 text-fg-secondary" />
          <div>
            <div className="text-base font-medium text-fg">Talk</div>
            <div className="text-xs text-fg-tertiary">Coming soon</div>
          </div>
        </button>
        <button
          type="button"
          onClick={() => navigate('/contacts/create/scan')}
          className="flex items-center gap-3 rounded-xl border border-line p-4 text-left hover:bg-surface-hover"
        >
          <PiCamera className="w-7 h-7 text-brand" />
          <div>
            <div className="text-base font-medium text-fg">Take a photo</div>
            <div className="text-xs text-fg-tertiary">
              Photograph a business card to prefill the form
            </div>
          </div>
        </button>
        <button
          type="button"
          onClick={() => navigate('/contacts/create/manual')}
          className="flex items-center gap-3 rounded-xl border border-line p-4 text-left hover:bg-surface-hover"
        >
          <PiPencilSimple className="w-7 h-7 text-fg-secondary" />
          <div>
            <div className="text-base font-medium text-fg">Enter manually</div>
            <div className="text-xs text-fg-tertiary">
              Type the details yourself
            </div>
          </div>
        </button>
      </div>
    </MobileModal>
  )
}
